import { render, staticRenderFns } from "./options.vue?vue&type=template&id=666056a0"
import script from "./options.vue?vue&type=script&lang=ts"
export * from "./options.vue?vue&type=script&lang=ts"
import style0 from "./options.vue?vue&type=style&index=0&id=666056a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports